import classNames from 'classnames';

import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import { TextInputUnwired } from 'src/app/components/Form/TextInput';
import type { TextInputUnwiredProps } from 'src/app/components/Form/TextInput';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

import styles from './styles.module.scss';

interface TextInputDecoratedUnwiredProps extends TextInputUnwiredProps {}

export const TextInputDecoratedUnwired = (props: TextInputDecoratedUnwiredProps) => {
  const hasError = !!props?.error;
  const classes = classNames({
    [styles.iconError]: hasError,
    [styles.icon]: !hasError,
  });

  return (
    <div className={styles.inputWithIcon}>
      <TextInputUnwired className={styles.input} {...props} />

      <div className={classes}>
        <CapsuleIcon iconString={CAPSULE_ICON_STRINGS.system_search} />
      </div>
    </div>
  );
};
